jQuery(function ($) {
$(function () {

  /*
  --------------------------------------
  スクロール処理
  waypoint
  --------------------------------------
  */
  $('.menu-message .menu-item, .box-about .photo, .box-about .contents, .box-about2 .photo, .box-about2 .contents').css('opacity',0);
  $('.bg-recruit, .bg-recruit .menu-item').css('opacity',0);
  $('.box-about .box-link, .box-about2 .box-link').css('opacity',0);

  // メニュー位置調整
  $(".site-header-front").waypoint(function (direction) {
    var activePoint = $(this.element);
    if (direction === 'down') {　//scroll down
        $(".site-header-front").addClass("fixed");
    } else {
        $(".site-header-front").removeClass("fixed");
    }
  }, { offset: '0%' });

  // message
  $(".menu-message").waypoint(function () {
    $(".menu-message .menu-item").addClass("animated fadeInLeftBig");
  }, { offset: '70%' });

  // about us
  $(".box-about").waypoint(function () {
    $(".box-about .photo").addClass("animated fadeInLeftBig");
    $(".box-about .contents").addClass("animated fadeInRightBig");
    $(".box-about .box-link").addClass("animated fadeInRightBig");
  }, { offset: '70%' });
  $(".box-about2").waypoint(function () {
    $(".box-about2 .photo").addClass("animated fadeInRightBig");
    $(".box-about2 .contents").addClass("animated fadeInLeftBig");
    $(".box-about2 .box-link").addClass("animated fadeInLeftBig");
  }, { offset: '70%' });

  // recruit
  $(".bg-recruit").waypoint(function () {
    $(".bg-recruit").addClass("animated fadeIn");
    $(".bg-recruit .menu-item").addClass("animated fadeInUp");
  }, { offset: '70%' });


  // if(navigator.userAgent.match(/(msie|MSIE) 10/i) || navigator.userAgent.match(/(T|t)rident\/7\./) || navigator.userAgent.match(/Edge\/\d+\.\d+/)) {
  //   $('body').on("mousewheel", function () {
  //     event.preventDefault();
  //     var wd = event.wheelDelta;
  //     var csp = window.pageYOffset;
  //     window.scrollTo(0, csp - wd);
  //   });
  // }

});
});